import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../../assets/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="logo-section">
                <Link to="/" onClick={closeMenu}>
                    <img src={logo} alt="Logo" className="logo" />
                </Link>    
            </div>

            <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                <Link to="/" onClick={closeMenu}>Home</Link>
                <Link to="/services" onClick={closeMenu}>Conditions We Treat</Link>
                <Link to="/about-us" onClick={closeMenu}>About Us</Link>
                <Link to="/medical-panel" onClick={closeMenu}>Medical panel</Link>
                <Link to="/blog" onClick={closeMenu}>Blog</Link>
                <Link to="/contact-us" onClick={closeMenu}>Contact Us</Link>
            </div>

            <div className="hamburger" onClick={toggleMenu}>
                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
        </header>
    );
}

export default Header;
